import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import StoreGroupLogo from './StoreGroupLogo'
import StorePage from './StorePage'
import yn from 'yn'

const StoreVoucher = ({ stores }) => {
  let virtualVouchers = yn(process.env.REACT_APP_VIRTUAL_VOUCHERS_ENABLED) && stores.virtualVouchers ? stores.virtualVouchers : []
  let physicalVouchers = yn(process.env.REACT_APP_PHYSICAL_VOUCHERS_ENABLED) && stores.physicalVouchers ? stores.physicalVouchers : []
  for (let v of virtualVouchers) {
    let voucherStore = stores.vouchers.find(x => x.supplierId === v.supplierId)
    v.imageUrl = voucherStore ? voucherStore.imageUrl : ''
  }
  for (let p of physicalVouchers) {
    let voucherStore = stores.vouchers.find(x => x.supplierId === p.supplierId)
    p.imageUrl = voucherStore ? voucherStore.imageUrl : ''
  }
  return (
    <Fragment>
      <Helmet>
        <title>{`Todos os cupons e serviços - ${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      {
        yn(process.env.REACT_APP_PHYSICAL_VOUCHERS_ENABLED) &&
        <StorePage>
          <div className='row'>
            <StoreGroupLogo
              items={physicalVouchers}
              title={process.env.REACT_APP_PHYSICAL_VOUCHERS_TITLE || 'Vouchers Físicos'}
              hasContent={physicalVouchers.length > 0}
              idLoading={stores.isLoading}
            />
          </div>
        </StorePage>
      }
      {
        yn(process.env.REACT_APP_VIRTUAL_VOUCHERS_ENABLED) &&
        <StorePage>
          <div className='row'>
            <StoreGroupLogo
              items={virtualVouchers}
              title={process.env.REACT_APP_VIRTUAL_VOUCHERS_TITLE || 'Vouchers Virtuais'}
              hasContent={virtualVouchers.length > 0}
            />
          </div>
        </StorePage>
      }
    </Fragment>
  )
}

StoreVoucher.propTypes = {
  stores: PropTypes.object.isRequired
}

const mapStateToProps = ({ stores }) => ({
  stores
})

export default connect(
  mapStateToProps,
  null
)(StoreVoucher)



// WEBPACK FOOTER //
// ./src/features/Store/StoreVoucher.js